// extracted by mini-css-extract-plugin
module.exports = {"content":"a10a3f92e9--content--oPaov"};